/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/index
 * @description Page component for managing vendors in the vendors management section.
 *   Displays a list of vendors with pagination, search functionality, and CRUD operations.
 *   Allows users to view, edit, and delete vendors with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Breadcrumb paths use /vendors and /payments-to-vendors without /UProcure prefix —
 *   should be /UProcure/vendors/... for correct navigation from PageTitle links.
 */

import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import VendorsList from "./list-vendors";
import AddNewVendor from "./add-new-vendor";
import VendorProfile from "./vendor-profile/vendor-profile";
import KycVerification from "./kyc-verification/nav-tab";
import PendingCertificates from "./pending-certificates";
import PaymentsToVendors from "./payments/payments-to-vendors";
import VendorFinanceDetails from "./payments/vendor-finance-details";
import MakePayment from "./payments/make-payment";
import PaymentCompleted from "./payments/payment-completed";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
const vendorBreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const vendorv2BreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Suppliers ',
    path: '/vendors',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Payments to Suppliers ',
    path: '/payments-to-vendors',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const vendorv3BreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Suppliers ',
    path: '/vendors',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Payments to Suppliers ',
    path: '/payments-to-vendors',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Supplier Finance Details',
    path: '/vendor-finance-details',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const VendorsManagementPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            index
            element={<Navigate to="/UProcure/vendors/list-vendors" />}
          />
          <Route
            path="list-vendors"
            element={
              <>
                <PageTitle breadcrumbs={vendorBreadCrumbs}>
                  Suppliers
                </PageTitle>
                <VendorsList />
              </>
            }
          />
          <Route
            path="add-new-vendor"
            element={
              <>
                <PageTitle breadcrumbs={vendorBreadCrumbs}>
                  Add New Vendor
                </PageTitle>
                <AddNewVendor />
              </>
            }
          />
          <Route
            path="vendor-profile"
            element={
              <>
                <PageTitle breadcrumbs={vendorBreadCrumbs}>
                  Vendor Profile
                </PageTitle>
                <VendorProfile />
              </>
            }
          />
          <Route
            path="kyc-verification"
            element={
              <>
                <PageTitle breadcrumbs={vendorBreadCrumbs}>
                  KYC Verification
                </PageTitle>
                <KycVerification />
              </>
            }
          />
          <Route
            path="pending-certificates"
            element={
              <>
                <PageTitle breadcrumbs={vendorBreadCrumbs}>
                  Pending Certificates
                </PageTitle>
                <PendingCertificates />
              </>
            }
          />
          <Route
            path="payments-to-vendors"
            element={
              <>
                <PageTitle breadcrumbs={vendorBreadCrumbs}>
                  Payments to Vendors
                </PageTitle>
                <PaymentsToVendors />
              </>
            }
          />
          <Route
            path="payments-to-vendors/vendor-finance-details"
            element={
              <>
                <PageTitle breadcrumbs={vendorv2BreadCrumbs}>
                  Vendor Finance Details
                </PageTitle>
                <VendorFinanceDetails />
              </>
            }
          />
          <Route
            path="payments-to-vendors/vendor-finance-details/make-payment"
            element={
              <>
                <PageTitle breadcrumbs={vendorv3BreadCrumbs}>
                  Make Payment
                </PageTitle>
                <MakePayment />
              </>
            }
          />
          <Route
            path="payments-to-vendors/vendor-finance-details/payment-completed"
            element={
              <>
                <PageTitle breadcrumbs={vendorv3BreadCrumbs}>
                  Payment Completed
                </PageTitle>
                <PaymentCompleted />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default VendorsManagementPage;
